import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HdLogComponent } from './hd-log.component';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { HdDetailLinesModule } from '../hd-detail-lines/hd-detail-lines.module';
import { HdLogService } from './hd-log.service';
@NgModule({
  imports: [
    CommonModule,
    NgZorroAntdModule,
    HdDetailLinesModule
  ],
  entryComponents: [HdLogComponent],
  declarations: [HdLogComponent],
  exports: [HdLogComponent],
  providers: [HdLogService]
})
export class HdLogModule { }
